import ScreenshotsWidget from './ScreenshotsWidget';

export default ScreenshotsWidget;
